export enum ListsActionTypes {
  SET_LOADING = "SET_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_CREATING_FAVORITE_LIST = "SET_CREATING_FAVORITE_LIST",
  ADD_LIST = "ADD_LIST",
  UPDATE_LIST = "UPDATE_LIST",
  DELETE_LIST = "DELETE_LIST",
  UPDATE_LIST_ITEMS = "UPDATE_LIST_ITEMS",
  SET_MY_LISTS = "SET_MY_LISTS",
  SET_PUBLIC_LISTS = "SET_PUBLIC_LISTS",
  SET_SHARED_LISTS = "SET_SHARED_LISTS",
  SET_SHARED_WITH_ME_LISTS = "SET_SHARED_WITH_ME_LISTS",
}

export enum ListType {
  MY_LISTS = "myLists",
  PUBLIC_LISTS = "publicLists",
  SHARED_LISTS = "sharedLists",
  SHARED_WITH_ME_LISTS = "sharedWithMeLists",
}
